import type { State } from '../../typings'
import { initialState } from '../../initState'

export const closeContentProducer = (state: State): State => ({
  ...initialState,
  filters: { ...state.filters },
  activityTypes: [...state.activityTypes],
  history: [...state.history],
  activities: [...state.activities],
})
